/**
 * Sets and deletes cookies related to user messages that prompt for mobile install
 * and push notifications.
 */
const userMessages = (function () {
    function setMessageCookie(name, value, days, hideElementID = null, useCounter = false) {
        const counterMaxAgeInSeconds = 3650 * 24 * 60 * 60; // 10 years
        // set default values for expiration
        let messageMaxAgeInSeconds = 14 * 2 * 24 * 60 * 60;
        let newNumDays = 7;
        /**
         * When using the counter, the counter will have the number of days the prior message
         * was set for expiration. Use this value and double it for the updated cookie.
         *
         * If not using the counter, use the 'days' parameter to set the expiration.
         */
        if (useCounter) {
            /**
             * Get the number of days from the existing counter cookie. Limit the resulting value
             * to 182 (half a year) as the maximum number of days to double.
             */
            const numDays = Math.min(
                Number(
                    document.cookie
                        .split("; ")
                        .find((row) => row.startsWith(`${name}NumDays=`))
                        ?.split("=")[1]
                ),
                182
            );

            if (Number.isInteger(numDays) && numDays > 0) {
                // Double the max-age of the last message cookie
                messageMaxAgeInSeconds = numDays * 2 * 24 * 60 * 60;
                newNumDays = numDays * 2;
            }
            document.cookie = `${name}=${value}; SameSite=Lax; Secure; max-age=${messageMaxAgeInSeconds}`;
            document.cookie = `${name}NumDays=${newNumDays}; SameSite=Lax; Secure; max-age=${counterMaxAgeInSeconds}`;
        } else {
            // Check if days parameter is provided and valid number
            if (Number.isInteger(days) && days > 0) {
                messageMaxAgeInSeconds = days * 24 * 60 * 60;
            } else {
                messageMaxAgeInSeconds = 14 * 24 * 60 * 60;
            }
            document.cookie = `${name}=${value}; SameSite=Lax; Secure; max-age=${messageMaxAgeInSeconds}`;
        }

        if (hideElementID !== null) {
            const element = document.getElementById(hideElementID);
            if (element !== null) {
                element.classList.add("e-fadeOut");

                setTimeout(() => {
                    element.classList.add("-hide");
                }, 800);
            }
        }
    }

    function deleteMessageCookie(name) {
        document.cookie = `${name}=; Path=/; SameSite=Strict; Secure; Expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }

    return {
        setMessageCookie: setMessageCookie,
        deleteMessageCookie: deleteMessageCookie,
    };
})();
export { userMessages };
